import { Box, createTheme, Menu, MenuItem, ThemeProvider } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LockIcon from "@mui/icons-material/Lock";
import BarLoader from "react-spinners/PulseLoader";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { css } from "@emotion/react";

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  border-color: #f5b848;
  z-index: 12;
`;

const TopNavbar = ({ title, id }) => {
  let history = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = getTitle(location.pathname);
    // setIsLoading(false);
  });

  // const handleCloseLoader = () => {
  //   setIsLoading(false);
  // };
  const handleLogout = async () => {};

  function getTitle(path) {
    let title = "";
    let default_txt = " - Fugetron Corporation";
    switch (path) {
      case "/":
        title = "Fugetron Corporation";
        break;
      case "/users":
        title = "Fugetron Corporation";
        break;
      case "/about-fugetron":
        title = "About Fugetron";
        break;
      case "/technology":
        title = "Technology";
        break;
      case "/contact-us":
        title = "Contact Us";
        break;
      case "/success-stories":
        title = "Success Stories";
        break;
      case "/qa-automation":
        title = "QA Automation";
        break;
      case "/cloud-migration-success-story":
        title = "Cloud Migration Success Story";
        break;
      case "/business-analysis":
        title = "Business Analysis";
        break;
      case "/application-development":
        title = "Application Development";
        break;
      case "/services-application-development":
        title = "Application Development";
        break;
      case "/advertising-domain":
        title = "Advertising Domain";
        break;
      case "/blogs":
        title = "Blogs";
        break;
      case "/vaadin":
        title = "Vaadin";
        break;
      case "/latest-qa-technologies":
        title = "Latest QA Technologies";
        break;
      case "/services":
        title = "Services";
        break;
      case "/staff-augmentation":
        title = "Staff Augmentation";
        break;
      case "/rpa":
        title = "RPA";
        break;
      case "/data":
        title = "Data Analytics";
        break;
      case "/contact-center":
        title = "Contact Center";
        break;
      case "/artificial-intelligence":
        title = "Artificial Intelligence";
        break;
      case "/job-opportunities":
        title = "Job Opportunities";
        break;
      case "/Web3blockchain":
        title = "Blockchain";
        break;
      default:
        // title = "Fugetron Corporation";
        break;
    }

    if (path !== "/" && path !== "/users") {
      title = title + default_txt;
    }

    return title;
  }

  // const renderMenu = (
  //   <Menu
  //     id="primary-search-account-menu"
  //     keepMounted
  //     open={isMenuOpen}
  //     onClose={() => setIsMenuOpen(false)}
  //   >
  //     <Box className="menuItems" onClick={() => history("/ChangePassword")}>
  //       <LockIcon className="mx-2" />
  //       <MenuItem style={{ padding: "0 5px" }}>Change Password</MenuItem>
  //     </Box>

  //     <Box className="menuItems" onClick={handleLogout}>
  //       <ExitToAppIcon className="mx-2" />
  //       <MenuItem style={{ padding: "0 5px" }}>Log Out</MenuItem>
  //     </Box>
  //   </Menu>
  // );

  return (
    <>
      <header id="site-header" class="header-footer-group" role="banner">
        <div class="container wrapper">
          <h1>
            <a onClick={() => history("/")} title="Fugetron Corporation">
              Fugetron Corporation
              <noscript>
                <img
                  src="img/Fugetron-Logo-New.png"
                  alt="Fugetron Corporation"
                />
              </noscript>
              <img
                class="lazyload"
                src="img/Fugetron-Logo-New.png"
                data-src="img/Fugetron-Logo-New.png"
                alt="Fugetron Corporation"
              />
            </a>
          </h1>
          <nav id="site-navigation" class="main-navigation">
            <span class="hamburger"></span>
            <div class="menu-header-menu-container">
              <ul id="primary-menu" class="menu new_primary_menu">
                <li
                  id="menu-item-1"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/" ? "current-menu-item" : ""
                  }`}
                >
                  <a
                    className="menu_nav"
                    title="Home"
                    onClick={() => history("/")}
                    target=""
                  >
                    Home
                  </a>
                  <span class="down-menu-arrow"></span>
                </li>
                <li
                  id="menu-item-2"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156 menu-item-has-children menu-item-156 ${
                    location.pathname === "/services" ? "current-menu-item" : ""
                  }`}
                >
                  <a
                    title="Services"
                    onClick={() => history("/services")}
                    target=""
                    className="menu_nav"
                  >
                    Services
                  </a>
                  <span class="down-menu-arrow"></span>
                  <ul class="sub-menu new_sub_menu">
                    <li
                      id="menu-item-1"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1 "
                    >
                      <a
                        onClick={() =>
                          history("/services-application-development")
                        }
                        target=""
                        className="menu_nav"
                      >
                        <div className="menu_icon">
                          <noscript>
                            <img src="img/application dev.png" alt="" />
                          </noscript>
                          <img
                            class="lazyload"
                            src="img/application dev.png"
                            data-src="img/application dev.png"
                            alt=""
                          />
                        </div>
                        <p class="head">Application Development</p>
                      </a>
                    </li>
                    <li
                      id="menu-item-2"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-2 "
                    >
                      <a
                        onClick={() => history("/data")}
                        target=""
                        className="menu_nav"
                      >
                        <div className="menu_icon">
                          <noscript>
                            <img src="img/Data modernization.png" alt="" />
                          </noscript>
                          <img
                            class="lazyload"
                            src="img/Data modernization.png"
                            data-src="img/Data modernization.png"
                            alt=""
                          />
                        </div>
                        <p class="head">Data Modernization & Analytics</p>
                      </a>
                    </li>
                    <li
                      id="menu-item-5"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-5 "
                    >
                      <a
                        onClick={() => history("/staff-augmentation")}
                        target=""
                        className="menu_nav"
                      >
                        <div className="menu_icon">
                          <noscript>
                            <img src="img/Managed services.png" alt="" />
                          </noscript>
                          <img
                            class="lazyload"
                            src="img/Managed services.png"
                            data-src="img/Managed services.png"
                            alt=""
                          />
                        </div>
                        <p class="head">Managed Services</p>
                      </a>
                    </li>
                    <li
                      id="menu-item-4"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-4 "
                    >
                      <a
                        onClick={() => history("/Web3blockchain")}
                        target=""
                        className="menu_nav"
                      >
                        <div className="menu_icon">
                          <noscript>
                            <img src="img/blockchain.png" alt="" />
                          </noscript>
                          <img
                            class="lazyload"
                            src="img/blockchain.png"
                            data-src="img/blockchain.png"
                            alt=""
                          />
                        </div>
                        <p class="head">Blockchain + iOT</p>
                      </a>
                    </li>
                    {/* <li
                      id="menu-item-3"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-3 "
                    >
                      <a onClick={() => history("/rpa")} target="" className="menu_nav">
                        <noscript>
                          <img
                            src="wp-content/uploads/2020/08/RPA.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="wp-content/uploads/2020/08/RPA.png"
                          data-src="wp-content/uploads/2020/08/RPA.png"
                          alt=""
                        />
                        <p class="head">RPA</p>
                        <p>
                          Helping businesses achieve their true potential by
                          relieving them of repetitive and mundane manual tasks.
                        </p>
                      </a>
                    </li> */}
                    {/* <li
                      id="menu-item-6"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-6 "
                    >
                      <a onClick={() => history("/contact-center")} target="" className="menu_nav">
                        <noscript>
                          <img src="img/Contact-Center.png" alt="" />
                        </noscript>
                        <img
                          class="lazyload"
                          src="img/Contact-Center.png"
                          data-src="img/Contact-Center.png"
                          alt=""
                        />
                        <p class="head">Contact Center</p>
                        <p>
                          An omnichannel contact center that helps you provide
                          superior customer service at a lower cost.
                        </p>
                      </a>
                    </li> */}
                  </ul>
                </li>
                {/* <li
                  id="menu-item-3"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/technology"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="Technology"
                    onClick={() => history("/technology")}
                    target=""
                    className="menu_nav"
                  >
                    Technology
                  </a>
                  <span class="down-menu-arrow"></span>
                </li> */}
                {/* <li
                  id="menu-item-4"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/about-fugetron"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="About Us"
                    onClick={() => history("/about-fugetron")}
                    target=""
                    className="menu_nav"
                  >
                    About Us
                  </a>
                  <span class="down-menu-arrow"></span> 
                </li> */}
                <li
                  id="menu-item-4"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/Partnerships"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="Partnerships"
                    onClick={() => history("/Partnerships")}
                    target=""
                    className="menu_nav"
                  >
                    Partnerships
                  </a>
                  <span class="down-menu-arrow"></span> 
                </li>

                <li
                  id="menu-item-5"
                  class="menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156 menu-item-has-children menu-item-156  "
                >
                  <a title="Resources" target="" className="menu_nav">
                    Accelerators
                  </a>
                   <span class="down-menu-arrow"></span>
                  <ul class="sub-menu new_sub_menu">
                    <li
                      id="menu-item-1"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1 "
                    >
                      <a
                        onClick={() => history("/marketing-accelerator")}
                        target=""
                        className="menu_nav"
                      >
                        <div className="menu_icon">
                          <noscript>
                            <img
                              src="img/Marketing.png"
                              alt=""
                            />
                          </noscript>
                          <img
                            class="lazyload"
                            src="img/Marketing.png"
                            data-src="img/Marketing.png"
                            alt=""
                          />
                        </div>
                        <p class="head">Marketing</p>
                      </a>
                    </li>
                  </ul>
                  {/* <ul class="sub-menu">
                    <li
                      id="menu-item-1"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1 "
                    >
                      <a
                        onClick={() => history("/marketing-accelerator")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img
                            src="wp-content/uploads/2021/11/icon-success-stories.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="wp-content/uploads/2021/11/icon-success-stories.png"
                          data-src="wp-content/uploads/2021/11/icon-success-stories.png"
                          alt=""
                        />
                        <p class="head">Marketing</p>
                        <p>Marketing Assets built on Alteryx</p>
                      </a>
                    </li>
                  </ul> */}
                </li>

                <li
                  id="menu-item-5"
                  class="menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156 menu-item-has-children menu-item-156  "
                >
                  <a title="Resources" target="" className="menu_nav">
                    Resources
                  </a>
                   <span class="down-menu-arrow"></span>
                  <ul class="sub-menu new_sub_menu">
                    <li
                      id="menu-item-1"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1 "
                    >
                      <a
                        onClick={() => history("/success-stories")}
                        target=""
                        className="menu_nav"
                      >
                       <div className="menu_icon">
                       <noscript>
                          <img
                            src="img/Success stoies.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="img/Success stoies.png"
                          data-src="img/Success stoies.png"
                          alt=""
                        />
                       </div>
                        <p class="head">Success Stories</p>
                      </a>
                    </li>
                    <li
                      id="menu-item-2"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-2 "
                    >
                      <a
                        onClick={() => history("/blogs")}
                        target=""
                        className="menu_nav"
                      >
                        <div className="menu_icon">
                          <noscript>
                            <img
                              src="img/Blogs.png"
                              alt=""
                            />
                          </noscript>
                          <img
                            class="lazyload"
                            src="img/Blogs.png"
                            data-src="img/Blogs.png"
                            alt=""
                          />
                        </div>
                        <p class="head">Blogs</p>
                      </a>
                    </li>
                    <li
                      id="menu-item-3"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-3 "
                    >
                      <a
                        onClick={() => history("/job-opportunities")}
                        target=""
                        className="menu_nav"
                      >
                        <div className="menu_icon">
                          <noscript>
                            <img
                              src="img/Careers.png"
                              alt=""
                            />
                          </noscript>
                          <img
                            class="lazyload"
                            src="img/Careers.png"
                            data-src="img/Careers.png"
                            alt=""
                          />
                        </div>
                        <p class="head">Careers</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-6"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/contact-us"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="Contact Us"
                    onClick={() => history("/contact-us")}
                    target=""
                    className="menu_nav"
                  >
                    Contact Us
                  </a>
                  <span class="down-menu-arrow"></span>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>



      {/* <div class="loader">
        <noscript>
          <img
            src="../sp-ao.shortpixel.ai/client/to_webp%2cq_glossy%2cret_img/https_/www.fugetroncorp.com/wp-content/uploads/2021/10/Loader.gif"
            alt="loader-icon"
          />
        </noscript>
        <img
          class="lazyload"
          src="../sp-ao.shortpixel.ai/client/q_lqip%2cret_wait/https_/www.fugetroncorp.com/wp-content/uploads/2021/10/Loader.svg"
          data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.fugetroncorp.com/wp-content/uploads/2021/10/Loader.gif"
          alt="loader-icon"
        />
        <span class="progress"></span>
      </div> */}


      {/* <header id="site-header" class="header-footer-group" role="banner">
        <div class="container wrapper">
          <h1>
            <a onClick={() => history("/")} title="Fugetron Corporation">
              Fugetron Corporation
              <noscript>
                <img
                  src="img/Fugetron-Logo-New.png"
                  alt="Fugetron Corporation"
                />
              </noscript>
              <img
                class="lazyload"
                src="img/Fugetron-Logo-New.png"
                data-src="img/Fugetron-Logo-New.png"
                alt="Fugetron Corporation"
              />
            </a>
          </h1>
          <nav id="site-navigation" class="main-navigation">
            <span class="hamburger"></span>
            <div class="menu-header-menu-container">
              <ul id="primary-menu" class="menu">
                <li
                  id="menu-item-1"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/" ? "current-menu-item" : ""
                  }`}
                >
                  <a
                    className="menu_nav"
                    title="Home"
                    onClick={() => history("/")}
                    target=""
                  >
                    Home
                  </a>
                  <span class="down-menu-arrow"></span>
                </li>
                <li
                  id="menu-item-2"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156 menu-item-has-children menu-item-156 ${
                    location.pathname === "/services" ? "current-menu-item" : ""
                  }`}
                >
                  <a
                    title="Services"
                    onClick={() => history("/services")}
                    target=""
                    className="menu_nav"
                  >
                    Services
                  </a>
                  <span class="down-menu-arrow"></span>
                  <ul class="sub-menu">
                    <li
                      id="menu-item-1"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1 "
                    >
                      <a
                        onClick={() =>
                          history("/services-application-development")
                        }
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img src="img/Component-45-–-1.png" alt="" />
                        </noscript>
                        <img
                          class="lazyload"
                          src="img/Component-45-–-1.png"
                          data-src="img/Component-45-–-1.png"
                          alt=""
                        />
                        <p class="head">Application Development</p>
                        <p>
                          A technology solution is merely a vehicle to business
                          success, not the end goal.
                        </p>
                      </a>
                    </li>
                    <li
                      id="menu-item-2"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-2 "
                    >
                      <a
                        onClick={() => history("/data")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img src="img/analysis.png" alt="" />
                        </noscript>
                        <img
                          class="lazyload"
                          src="img/analysis.png"
                          data-src="img/analysis.png"
                          alt=""
                        />
                        <p class="head">Data Modernization & Analytics</p>
                        <p>
                          We help businesses realize the true power of data and
                          evangelize the same throughout their decision making
                          process.
                        </p>
                      </a>
                    </li>
                    <li
                      id="menu-item-5"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-5 "
                    >
                      <a
                        onClick={() => history("/staff-augmentation")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img src="img/Staff-Aug.png" alt="" />
                        </noscript>
                        <img
                          class="lazyload"
                          src="img/Staff-Aug.png"
                          data-src="img/Staff-Aug.png"
                          alt=""
                        />
                        <p class="head">Managed Services</p>
                        <p>
                          Fully managed delivery teams to individual expert
                          software engineers.
                        </p>
                      </a>
                    </li>

                    <li
                      id="menu-item-4"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-4 "
                    >
                      <a
                        onClick={() => history("/Web3blockchain")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img src="wp-content/uploads/2020/08/AI.svg" alt="" />
                        </noscript>
                        <img
                          class="lazyload"
                          src="img/blockchain-icon-blue.png"
                          data-src="img/blockchain-icon-blue.png"
                          alt=""
                        />
                        <p class="head">Blockchain + iOT</p>
                        <p>
                          Talk to our team of experts about how blockchain
                          technology fits within your eco system
                        </p>
                      </a>
                    </li>
                    <li
                      id="menu-item-3"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-3 "
                    >
                      <a onClick={() => history("/rpa")} target="" className="menu_nav">
                        <noscript>
                          <img
                            src="wp-content/uploads/2020/08/RPA.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="wp-content/uploads/2020/08/RPA.png"
                          data-src="wp-content/uploads/2020/08/RPA.png"
                          alt=""
                        />
                        <p class="head">RPA</p>
                        <p>
                          Helping businesses achieve their true potential by
                          relieving them of repetitive and mundane manual tasks.
                        </p>
                      </a>
                    </li>
                    <li
                      id="menu-item-6"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-6 "
                    >
                      <a onClick={() => history("/contact-center")} target="" className="menu_nav">
                        <noscript>
                          <img src="img/Contact-Center.png" alt="" />
                        </noscript>
                        <img
                          class="lazyload"
                          src="img/Contact-Center.png"
                          data-src="img/Contact-Center.png"
                          alt=""
                        />
                        <p class="head">Contact Center</p>
                        <p>
                          An omnichannel contact center that helps you provide
                          superior customer service at a lower cost.
                        </p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-3"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/technology"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="Technology"
                    onClick={() => history("/technology")}
                    target=""
                    className="menu_nav"
                  >
                    Technology
                  </a>
                  <span class="down-menu-arrow"></span>
                </li>
                <li
                  id="menu-item-4"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/about-fugetron"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="About Us"
                    onClick={() => history("/about-fugetron")}
                    target=""
                    className="menu_nav"
                  >
                    About Us
                  </a>
                  <span class="down-menu-arrow"></span> 
                </li>
                <li
                  id="menu-item-4"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/Partnerships"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="Partnerships"
                    onClick={() => history("/Partnerships")}
                    target=""
                    className="menu_nav"
                  >
                    Partnerships
                  </a>
                  <span class="down-menu-arrow"></span> 
                </li>

                <li
                  id="menu-item-5"
                  class="menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156 menu-item-has-children menu-item-156  "
                >
                  <a title="Resources" target="" className="menu_nav">
                    Accelerators
                  </a>
                   <span class="down-menu-arrow"></span>
                  <ul class="sub-menu">
                    <li
                      id="menu-item-1"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1 "
                    >
                      <a
                        onClick={() => history("/marketing-accelerator")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img
                            src="wp-content/uploads/2021/11/icon-success-stories.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="wp-content/uploads/2021/11/icon-success-stories.png"
                          data-src="wp-content/uploads/2021/11/icon-success-stories.png"
                          alt=""
                        />
                        <p class="head">Marketing</p>
                        <p>Marketing Assets built on Alteryx</p>
                      </a>
                    </li>
                  </ul>
                </li>

                <li
                  id="menu-item-5"
                  class="menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156 menu-item-has-children menu-item-156  "
                >
                  <a title="Resources" target="" className="menu_nav">
                    Resources
                  </a>
                   <span class="down-menu-arrow"></span>
                  <ul class="sub-menu">
                    <li
                      id="menu-item-1"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-1 "
                    >
                      <a
                        onClick={() => history("/success-stories")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img
                            src="wp-content/uploads/2021/11/icon-success-stories.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="wp-content/uploads/2021/11/icon-success-stories.png"
                          data-src="wp-content/uploads/2021/11/icon-success-stories.png"
                          alt=""
                        />
                        <p class="head">Success Stories</p>
                        <p>
                          Inspirational success stories to keep you striving for
                          your dreams
                        </p>
                      </a>
                    </li>
                    <li
                      id="menu-item-2"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-2 "
                    >
                      <a
                        onClick={() => history("/blogs")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img
                            src="wp-content/uploads/2021/11/icon-blog.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="wp-content/uploads/2021/11/icon-blog.png"
                          data-src="wp-content/uploads/2021/11/icon-blog.png"
                          alt=""
                        />
                        <p class="head">Blogs</p>
                        <p>
                          A powerful way of demonstrating knowledge and building
                          trust as an expert in your niche
                        </p>
                      </a>
                    </li>
                    <li
                      id="menu-item-3"
                      class="menu-item menu-item-type-post_type menu-item-object-services menu-item-3 "
                    >
                      <a
                        onClick={() => history("/job-opportunities")}
                        target=""
                        className="menu_nav"
                      >
                        <noscript>
                          <img
                            src="wp-content/uploads/2021/10/personal-growth.png"
                            alt=""
                          />
                        </noscript>
                        <img
                          class="lazyload"
                          src="wp-content/uploads/2021/10/personal-growth.png"
                          data-src="wp-content/uploads/2021/10/personal-growth.png"
                          alt=""
                        />
                        <p class="head">Careers</p>
                        <p>
                          Looking for your dream job? Discover job
                          opportunities. Bring your best ideas – and we'll make
                          them come to life
                        </p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-6"
                  class={`menu-item menu-item-type-post_type menu-item-object-page page_item page-item-156  menu-item-156 ${
                    location.pathname === "/contact-us"
                      ? "current-menu-item"
                      : ""
                  }`}
                >
                  <a
                    title="Contact Us"
                    onClick={() => history("/contact-us")}
                    target=""
                    className="menu_nav"
                  >
                    Contact Us
                  </a>
                  <span class="down-menu-arrow"></span>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header> */}
    </>
  );
};

export default TopNavbar;
